// todo
import { createAction } from '@ngrx/store';

export const idleTimeout = createAction(
  '[DOM] Idle Timeout'
);
